<template>
    <v-app :dark="$vuetify.theme.dark" :lang="$i18n.locale">
        <Viewer />
        <Alert />
    </v-app>
</template>

<script>
import Viewer from "./components/core/RouterViewComponent";
import Alert from "./components/global/AlertComponent";
import groupRules from "./utils/ability";

export default {
    name: "App",
    components: {
        Viewer,
        Alert,
    },
    watch: {
        // Handles authentication and authorization
        // Trying to access the login route when logged in will
        // redirect to the homepage (/home).
        // When NOT trying to access the login route check user's permission
        // to read the specified route.
        $route: {
            async handler(newRoute) {
                // Check API endpoint
                await this.$store.dispatch("isLoggedIn");
                // Update rules
                const rules = groupRules(
                    this.$store.getters.getLoggedUserGroup
                );
                this.$ability.update(rules);
                // Check route
                const { name } = newRoute;
                const route = name && name.split(" ").join("").toLowerCase();
                const goToLogin = route === "login";
                const goToHome = route === "home";
                const authentication = this.$store.getters.isAuthenticated;
                const authorization = this.$can("read", route);
                if (
                    !goToHome &&
                    ((!goToLogin && !authorization) ||
                        (goToLogin && authentication))
                ) {
                    this.$router.push("/");
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
